export default __webpack_public_path__ + "static/media/continue-saved-article.912f43a9.svg";